import * as yup from "yup";
import { emailSchema } from 'validations/common';

export const CreateAlertSchema = yup.object().shape({
    query_id: yup.number().required("Please select a query"),
    value_column: yup.string().required("Please select a column"),
    condition: yup.string().required("Please select a condition"),
    threshold: yup.string().required("Please input the threshold"),
    email: emailSchema,
});